import { Link } from "react-router-dom";
import Wordmark from "../Wordmark/Wordmark";
import {
  availableLegalLinkIds,
  contactChannelHasValue,
  contactChannelsWithValue,
  LEGAL_LINK_ROUTES,
} from "./publicSitePolicy";
import "./PublicSiteFooter.css";

function WhatsAppMark() {
  return (
    <svg
      aria-hidden="true"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M20.52 3.48A11.8 11.8 0 0 0 1.7 17.85L1 23l5.3-1.39A11.8 11.8 0 0 0 12 23.8 11.8 11.8 0 0 0 20.52 3.48zM12 21.64a9.7 9.7 0 0 1-4.94-1.35l-.35-.21-3.15.82.84-3.07-.23-.38A9.66 9.66 0 1 1 12 21.64zm5.3-7.24c-.23-.12-1.36-.67-1.57-.75-.21-.08-.36-.12-.51.12-.15.23-.59.75-.72.9-.13.15-.27.17-.5.06-.23-.12-.97-.36-1.85-1.14-.68-.61-1.14-1.36-1.28-1.59-.13-.23-.01-.36.1-.47.1-.1.23-.27.35-.4.12-.13.15-.23.23-.38.08-.15.04-.29-.02-.4-.06-.12-.51-1.23-.7-1.68-.18-.44-.37-.38-.51-.39h-.44c-.15 0-.4.06-.6.29-.21.23-.8.78-.8 1.9 0 1.12.82 2.2.93 2.35.12.15 1.61 2.46 3.9 3.45 1.45.63 2.02.68 2.75.57.42-.07 1.36-.56 1.55-1.1.19-.53.19-.99.13-1.09-.06-.1-.21-.15-.44-.27z" />
    </svg>
  );
}

function InstagramMark() {
  return (
    <svg
      aria-hidden="true"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        d="M7.5 2h9A5.5 5.5 0 0 1 22 7.5v9A5.5 5.5 0 0 1 16.5 22h-9A5.5 5.5 0 0 1 2 16.5v-9A5.5 5.5 0 0 1 7.5 2zm0 2A3.5 3.5 0 0 0 4 7.5v9A3.5 3.5 0 0 0 7.5 20h9a3.5 3.5 0 0 0 3.5-3.5v-9A3.5 3.5 0 0 0 16.5 4h-9zM12 8a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm0 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 12 10zm5.25-3.25a1.15 1.15 0 1 1 0 2.3 1.15 1.15 0 0 1 0-2.3z"
      />
    </svg>
  );
}

function EmailMark() {
  return (
    <svg
      aria-hidden="true"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z" />
    </svg>
  );
}

function ChannelMark({ id }: { id: string }) {
  if (id === "whatsapp") return <WhatsAppMark />;
  if (id === "instagram") return <InstagramMark />;
  if (id === "email") return <EmailMark />;
  return null;
}

function isHttpUrl(value: string): boolean {
  return value.startsWith("http://") || value.startsWith("https://");
}

function channelVisibleText(value: string, label: string): string {
  return isHttpUrl(value) ? label : value;
}

export default function PublicSiteFooter() {
  const channels = contactChannelsWithValue().filter(contactChannelHasValue);
  const legalLinkIds = availableLegalLinkIds();

  return (
    <footer className="psf" aria-label="Rodapé">
      <div className="psf-top">
        <div className="psf-brand">
          <div className="psf-logo">
            <Wordmark width={190} variant="dark" to="/" label="Acertei Questões" />
          </div>
          {channels.length > 0 ? (
            <div className="psf-social">
              {channels.map((channel) => {
                const external = isHttpUrl(channel.href);
                return (
                  <a
                    key={channel.id}
                    className="psf-social-link"
                    href={channel.href}
                    target={external ? "_blank" : undefined}
                    rel={external ? "noopener noreferrer" : undefined}
                  >
                    <ChannelMark id={channel.id} />
                    {channelVisibleText(channel.value, channel.label)}
                    {external ? <span className="psf-sr"> (abre em nova aba)</span> : null}
                  </a>
                );
              })}
            </div>
          ) : null}
        </div>
        <nav className="psf-legal" aria-label="Institucional">
          {legalLinkIds.map((id) => {
            const route = LEGAL_LINK_ROUTES[id];
            return (
              <Link key={id} className="psf-legal-link" to={route.to}>
                {route.label}
              </Link>
            );
          })}
          <Link className="psf-legal-link" to="/contato">
            Contato
          </Link>
        </nav>
      </div>
      <div className="psf-rule" />
      <div className="psf-copy">
        <p className="psf-copyright">© 2026 Acertei Questões</p>
      </div>
    </footer>
  );
}
